import React from 'react';
import { RouteComponentProps, Switch } from 'react-router-dom';
import { renderRoutesInPath } from '~/utils/RouterUtils';

interface PageWrapperProps extends RouteComponentProps {
  routes: any[];
}

const PageWrapper: React.FunctionComponent<PageWrapperProps> = props => {
  const { routes = [], match } = props;
  return (
    <div className="col-1-1">
      <Switch children={renderRoutesInPath(routes, match.path)} />
    </div>
  );
};
export default PageWrapper;
